<app-mu-sidebar
  customClass="express-add-wire-transfer-modal-anchor express-add-wire-transfer-content"
  [contentClass]="customClass"
  [flagList]="flagList"
  [showFlag]="showFlag"
  [skin]="skin"
>
  <app-mu-form-section [gridSizeForm]="12" class="mu-full-width" [withAbsoluteButtons]="true">
    <div class="p-grid">
      <div class="p-col-12 mu-payments-add-wire-transfer-right-logo">
        <img class="img-kushki" src="/assets/images/logo-transfer-wire.svg" alt="logo-transferencia-bancaria" />
      </div>
      <div class="p-col-12 mu-payments-add-wire-transfer-right-copy mu-without-padding" [innerHTML]="'common.copyRight' | translate"></div>

      <ng-container *ngIf="!flagList?.get(showWireFlag); else blockWireTransferSuccess">
        <form class="p-grid mu-form-content" [formGroup]="formData" appValidator autocomplete="off">
          <div class="p-grid">
            <app-mu-form-fieldset
              label="emailWireTransfer"
              [showLoading]="flagList?.get(checkEmailFlag)"
              [customGridCol]="12"
              class="mu-without-padding"
            >
              <input
                type="email"
                id="emailWireTransfer"
                name="emailWireTransfer"
                [placeholder]="'form.placeholder.emailWireTransfer' | translate"
                formControlName="emailWireTransfer"
              />
            </app-mu-form-fieldset>
            <app-mu-form-buttons
              [customGridCol]="12"
              [alwaysFullWidth]="false"
              class="mu-payments-add-wire-transfer-right-buttons mu-without-padding"
            >
              <p-button
                muButtonLeft
                [label]="'form.button.cancel' | translate"
                class="mu-button mu-button-outline"
                type="button"
                (click)="cancel()"
              >
              </p-button>
              <p-button
                muButtonRight
                [label]="'form.button.saveWireTransfer' | translate"
                class="mu-button mu-button-full-width button-submit"
                type="button"
                (click)="save()"
                [disabled]="formData.get('isInvalidForm').value"
              >
                <app-loading [showLoading]="flagList?.get(loaderFlag)" type="icon"></app-loading>
              </p-button>
            </app-mu-form-buttons>
            <div class="p-col-12 mu-payments-add-wire-transfer-notification">
              <span mu-icon class="mu-bg-notificacion"><i class="fas fa-info" aria-hidden="true"></i></span>
              <p [innerHTML]="'common.msgWireTransfer' | translate"></p>
            </div>
          </div>
        </form>
      </ng-container>
      <ng-template #blockWireTransferSuccess>
        <div class="p-grip mu-payments-add-wire-transfer-information">
          <div class="p-col-12 mu-payments-add-wire-transfer-information-item">{{ dataWireTransferMx?.email }}</div>
          <div class="p-col-12 mu-payments-add-wire-transfer-information-item mu-clabe">
            <span
              >Clabe: &nbsp;<span class="mu-payments-add-wire-transfer-clabe" id="mu-clabe">{{
                dataWireTransferMx?.response.clabe
              }}</span></span
            >
            <span
              mu-icon
              class="mu-payments-add-wire-transfer-icon"
              [pTooltip]="'transaction.paymentMethod.copyClabe' | translate"
              tooltipPosition="top"
              tooltipStyleClass="mu-tooltip-large"
              (click)="copy()"
            >
              <i class="fas fa-clone" aria-hidden="true"></i>
            </span>
          </div>
          <div class="p-col-12 mu-payments-add-wire-transfer-information-item">
            {{ 'transaction.paymentMethod.referenceNumber' | translate }}: &nbsp;{{ dataWireTransferMx?.response.referenceNumber }}
          </div>
          <div class="p-col-12 mu-payments-add-wire-transfer-information-item">
            {{ 'transaction.paymentMethod.totalValue' | translate }}: &nbsp;
            <span class="mu-paymenst-add-wire-transfer-total-value">{{
              utils.formatCurrency(dataWireTransferMx?.totalValue || 0, country)
            }}</span>
          </div>
        </div>

        <div class="mu-payments-add-wire-transfer-buttons">
          <app-mu-form-buttons [customGridCol]="12" [alwaysFullWidth]="true">
            <p-button
              muButtonLeft
              [label]="'form.button.backHistoryRecharge' | translate"
              class="mu-button mu-button-full-width button-submit"
              [routerLink]="'/metodos-de-pago/metodo-pago'"
              [queryParams]="{currentTab:'1'}"
            >
              <app-loading [showLoading]="flagList?.get(loaderFlag)" type="icon"></app-loading>
            </p-button>
          </app-mu-form-buttons>
        </div>
      </ng-template>
    </div>
  </app-mu-form-section>
</app-mu-sidebar>
